import { html, htmlHorizontal } from './template';

export class AdGenHelper {
  static generateHtml(options) {
    // console.log('options.data:', options)
    // const html = fs.readFileSync(__dirname + '/template.html', 'utf8')
    // console.log('invoice html:', html)

    const Handlebars = require('handlebars')
    Handlebars.registerHelper('undefined', (value) => {
      return value === undefined
    })
    Handlebars.registerHelper('newLine', (value) => {
      return value === ''
    })

    Handlebars.registerHelper('ifLogoPlacementTop', function (conditional, options) {
      if (conditional === 'TOP') {
        return options.fn(this);
      }
    });

    Handlebars.registerHelper('ifLogoPlacementBottom', function (conditional, options) {
      if (conditional === 'BOTTOM') {
        return options.fn(this);
      }
    });

    Handlebars.registerHelper('ifTextPlacementAboveHero', function (conditional, options) {
      if (conditional === 'ABOVEHERO') {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });

    Handlebars.registerHelper('ifTextPlacementBelowHero', function (conditional, options) {
      if (conditional === 'BELOWHERO') {
        return options.fn(this);
      }
    });

    Handlebars.registerHelper('ifHeroImageMode', function (conditional, options) {
      if (conditional === 'SQUARE') {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });
    Handlebars.registerHelper('ifText', function (conditional, options) {
      if (conditional) {
        return options.fn(this);
      }
    });
    Handlebars.registerHelper('ifSubText', function (conditional, options) {
      if (conditional) {
        return options.fn(this);
      }
    });
    Handlebars.registerHelper('ifLogoLink', function (conditional, options) {
      if (conditional) {
        return options.fn(this);
      }
    });

    Handlebars.registerHelper('ifTextPlacementRightHero', function(conditional, options) {
      if (conditional === 'RIGHTHERO') {
        return options.fn(this);
      }else {
        return options.inverse(this);
      }
    });
    Handlebars.registerHelper('ifTextPlacementLeftHero', function(conditional, options) {
      if (conditional === 'LEFTHERO') {
        return options.fn(this);
      }else {
        return options.inverse(this);
      }
    });
    Handlebars.registerHelper('ifContent', function (conditional1, conditional2, conditional3, options) {
      if (conditional1 || conditional2 || conditional3) {
        return options.fn(this);
      }
    });

    const template = options.orientation === 'horizontal' ? Handlebars.compile(htmlHorizontal) : Handlebars.compile(html)
    return { html: template(options) }
  }
}




// WEBPACK FOOTER //
// ./src/helpers/AdGenHelper.js